import {
  CHANGE_LANGUAGE_FAIL,
  CHANGE_LANGUAGE_SUCCESS,
  EDIT_USER_FAIL,
  EDIT_USER_LOADING,
  EDIT_USER_SUCCESS,
  PIN_FORM_FAIL,
  PIN_FORM_LOADING,
  PIN_FORM_SUCCESS,
} from '../types';

const initialState = {
  language: null,
  pinnedFormIds: [],
  isLoading: false,
  error: null,
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case EDIT_USER_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CHANGE_LANGUAGE_SUCCESS:
      return {
        ...state,
        language: payload,
      };

    case EDIT_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case PIN_FORM_SUCCESS:
      return {
        ...state,
        pinnedFormIds: payload,
      };
    case EDIT_USER_FAIL:
    case CHANGE_LANGUAGE_FAIL:
    case PIN_FORM_FAIL:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    default:
      return state;
  }
}
